import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SortOption, SortTypes } from '~shared/modules/application-event/models/sort-option.model';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { ProductsSortedApplicationEvent } from '~shared/modules/application-event/models';
import { select, Store } from '@ngrx/store';
import { getSortOption, SetSort, SortState } from '~app/modules/catalog/store';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-search-sort-toggler',
  templateUrl: './sort-toggler.component.html',
  styleUrls: ['./sort-toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortTogglerComponent implements OnInit, OnDestroy {
  @Input() isCategoryPage: boolean;

  selectedOption$: Observable<SortOption>;
  sortOptions: SortOption[] = SortTypes.slice();

  private unsubscribe$ = new Subject();

  constructor(private store: Store<SortState>, private applicationEventService: ApplicationEventService) {
    this.selectedOption$ = this.store.pipe(select(getSortOption));
  }

  ngOnInit(): void {
    if (!this.isCategoryPage) {
      // TODO: removing new arrivals sort option until it can be used in all pages
      this.sortOptions.pop();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSortChange(id: number): void {
    const orderOption: SortOption = this.sortOptions.find((o) => o.id === +id);
    this.applyPriceSort(orderOption || this.sortOptions[0]);
  }

  private applyPriceSort(orderOption: SortOption): void {
    this.applicationEventService.publish(new ProductsSortedApplicationEvent(orderOption));
    this.store.dispatch(new SetSort(orderOption.code));
  }
}
